import { render, staticRenderFns } from "./DataTablePlanificacionSemanal.vue?vue&type=template&id=aff47654&scoped=true"
import script from "./DataTablePlanificacionSemanal.vue?vue&type=script&lang=js"
export * from "./DataTablePlanificacionSemanal.vue?vue&type=script&lang=js"
import style0 from "./DataTablePlanificacionSemanal.vue?vue&type=style&index=0&id=aff47654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff47654",
  null
  
)

export default component.exports